var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pay-plan-row-menu"},[(_setup.menuItems.length > 0)?_c(_setup.MenuIcon,{attrs:{"dropdownItems":_setup.menuItems,"isOpen":_setup.isOpen},on:{"onClick":_setup.handleMenuClick}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }